import { Dropdown } from 'bootstrap'

const navbar = document.querySelector('.wp-block-yellowtree-navbar')

navbar?.addEventListener('hide.bs.offcanvas', () => {
  const dropdownToggles = document.querySelectorAll(
    '.mobile-main-nav-switcher > button'
  )
  for (const toggle of dropdownToggles) {
    const switcherDropdown = Dropdown.getOrCreateInstance(toggle ?? '')
    switcherDropdown?.hide()
  }
})

const locationSwitcherButton = document.getElementById(
  'mobile-location-switcher-button'
)
const languageSwitcherButton = document.getElementById(
  'mobile-language-switcher-button'
)

locationSwitcherButton?.addEventListener('show.bs.dropdown', () => {
  const instance = Dropdown.getOrCreateInstance(languageSwitcherButton ?? '')
  instance?.hide()
})

languageSwitcherButton?.addEventListener('show.bs.dropdown', () => {
  const instance = Dropdown.getOrCreateInstance(locationSwitcherButton ?? '')
  instance?.hide()
})
